<template>
    <ActionDialog
        v-model="internal_value"
        :title="title"
    >
        <template #content>
            <v-window
                v-model="window"
                :disabled="true"
            >
                <v-window-item value="select">
                    <AmortizationSelect @next="window = 'setup'" />
                </v-window-item>
                <v-window-item value="setup">
                    <AmortizationSetup
                        @back="window = 'select'"
                        @cancel="internal_value = false"
                        @confirm="post_amortization"
                    />
                </v-window-item>
                <v-window-item value="feedback">
                    <AmortizationFeedback
                        :amortization_date="amortization_date"
                        :feedback="feedback"
                        @close="internal_value = false"
                    />
                </v-window-item>
            </v-window>
        </template>
    </ActionDialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { locales_mixin } from '@old/mixins/locales_mixin'
import { api_mixin } from '@old/mixins/api_mixin'
import AmortizationFeedback from '@old/components/amortization/AmortizationFeedback.vue'
import { actions_mixin } from '@old/mixins/actions_mixin'
import AmortizationSetup from '@old/components/amortization/AmortizationSetup.vue'
import AmortizationSelect from '@old/components/amortization/AmortizationSelect.vue'
import ActionDialog from '@old/components/action_dialog/index.vue'

export default {
    name: 'Amortization',
    props: {
        modelValue: {
            type: Boolean,
        },
    },
    mixins: [actions_mixin, api_mixin, locales_mixin],
    components: {
        ActionDialog,
        AmortizationSelect,
        AmortizationSetup,
        AmortizationFeedback,
    },
    data() {
        return {
            internal_value: false,
            feedback: null,
            window: null,
            amortization_date: '',
            document_ids_to_remove: [],
        }
    },
    computed: {

        title() {
            if (this.window !== 'feedback') return this.translate('common.split_your_payment')
            return ''
        },
        ...mapGetters([]),
        ...mapState(['amortization']),
    },
    watch: {
        amortization: {
            handler(amortization) {
                if (this.internal_value) return
                if (Object.keys(amortization.document).length) {
                    this.internal_value = true
                    this.window = 'setup'
                } else if (amortization.multiple.documents.length) {
                    this.internal_value = true
                    this.window = 'select'
                }
            },
            immediate: true,
            deep: true,
        },
        async internal_value(value) {
            if (!value) {
                this.set_state_property({
                    property: 'amortization',
                    data: {
                        ...this.amortization,
                        document: {},
                        multiple: {
                            documents: [],
                            selected: [],
                        },
                    },
                })
                if (this.window === 'feedback') {
                    this.$nextTick(() => {
                        if (this.$route['name'] !== 'Home') {
                            this.$router.push('/')
                        }
                        this.set_state_property({
                            property: 'remove_document_ids',
                            data: this.document_ids_to_remove,
                        })
                        this.update_actions_render_key()
                    })
                }
                this.feedback = null
                this.window = null
            }
        },
        feedback(value) {
            if (value) this.window = 'feedback'
        },
    },
    methods: {
        async post_amortization(payload) {
            this.amortization_date = payload['amortization_date']
            try {
                const { id } = this.amortization.params
                await this.api_post({
                    url: `/domain-actions/cases/new_amortization/${id}`,
                    data: payload,
                })
                this.feedback = 'success'
                this.document_ids_to_remove = [
                    ...payload['cases'].map((v) => v['id']),
                    ...payload['debt_collections'].map((v) => v['id']),
                    ...payload['enforcements'].map((v) => v['id']),
                ]
            } catch (e) {
                console.log(e)
                this.feedback = 'failed'
            }
        },
        ...mapActions(['set_state_property', 'update_key_in_state_property']),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
    unmounted() {},
}
</script>

<style scoped lang="sass"></style>
